import * as React from "react";
import { SVGProps } from "react";

const Zilliqa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    viewBox="0 0 308 436"
    {...props}
  >
    <style>{".st0{fill:#49c1bf}.st2{fill:#298e97}"}</style>
    <g transform="translate(190.693 -109)">
      <path
        id="path0_fill"
        d="m117.4 289.2-62.8 28L-112 402l166.6 80.1V349.7l62.8-28.3V517l-62.8 28-245.3-117.4v-62.4l169.8-83.3-169.8-81.6V137l63.8-28 244.3 117.6v62.6z"
        className="st0"
      />
    </g>
    <g transform="translate(190.693 -109)">
      <path
        id="path1_fill"
        fill="#077a8f"
        d="M-190.7 137 54.6 254.6l62.8-28L-126.9 109l-63.8 28z"
      />
    </g>
    <g transform="translate(208.695 -100.365)">
      <path
        id="path2_fill"
        d="m36.6 245.7 62.8-28v62.6l-62.8 28v-62.6z"
        className="st2"
      />
    </g>
    <g transform="translate(190.693 -106.944)">
      <path
        id="path3_fill"
        d="M-190.7 135v63.3l169.8 81.6-169.8 83.3v62.4L54.6 543v-62.8L-112 400l166.6-84.8v-62.6L-190.7 135z"
        className="st0"
      />
    </g>
    <g transform="translate(208.695 -93.411)">
      <path
        id="path4_fill"
        d="m36.6 529 62.8-28V305.4l-62.8 28.3V529z"
        className="st2"
      />
    </g>
  </svg>
);

export default Zilliqa;
